export enum IPeriodicTime {
    MONTHLY = "monthly",
    BIMONTHLY = "bimonthly",
    QUARTERLY = "quarterly",
    SEMESTERLY = "semesterly",
    YEARLY = "yearly",
    SPECIFIC = "specific",
    ON_DEMAND = "on_demand",
    FREE = "free",
}

export enum IProductType {
    CASH_CARRY = "cash_carry",
    DIGITAL_CONTENT = "digital_content",
    DIGITAL_GOODS = "digital_goods",
    DIGITAL_PHYSICAL = "digital_physical",
    GIFT_CARD = "gift_card",
    PHYSICAL_GOODS = "physical_goods",
    RENEW_SUBS = "renew_subs",
    SHAREWARE = "shareware",
    SERVICE = "service",
  }

export enum IPaymentMethodNotify {
    CREDIT = "credit",
    DEBIT = "debit",
    BOLETO = "boleto",
    PIX = "pix",
  }
  